import { resolveRouteTabMeta } from '../router/routeMeta';
import { isTabRouteKeepAliveEnabled } from './tabKeepAliveEnv';
import { isTabFeatureEnabled } from './tabFeatureSwitch';

/** 将 pathname+search 形式的 key 拆成 routeMeta 所需参数 */
export function parseFullPathForMeta(fullPathOrKey: string) {
  const q = fullPathOrKey.indexOf('?');
  const pathname = q === -1 ? fullPathOrKey : fullPathOrKey.slice(0, q);
  const search = q === -1 ? '' : fullPathOrKey.slice(q);
  return { pathname, search, fullPath: fullPathOrKey };
}

/**
 * 是否允许在 `tabStore.stateCache` 里持久化**业务快照**（分页、筛选等）。
 *
 * - `instance` + KeepAlive 打开时仍返回 **true**：KeepAlive 与 react-router 组合下，Outlet
 *   再次激活时可能重挂载子树，仅靠实例缓存不一定保住分页；stateCache 作为**补充**避免切回第 1 页再请求。
 * - `state`：允许。
 * - `none`：不允许。
 */
export function allowsTabStoreStateCache(fullPathOrKey: string): boolean {
  if (!isTabFeatureEnabled()) {
    return false;
  }
  const { pathname, search, fullPath } = parseFullPathForMeta(fullPathOrKey);
  const meta = resolveRouteTabMeta(pathname, search, fullPath);
  return meta.cacheStrategy !== 'none';
}

/**
 * 是否允许用 `stateCache` 恢复 **layout 外层** `contentWrapper` 的滚动条。
 *
 * - KeepAlive 打开时：`instance` 页以页内滚动为主，外层滚回顶，避免双滚动串扰。
 */
export function allowsLayoutScrollStateCache(fullPathOrKey: string): boolean {
  if (!isTabFeatureEnabled()) {
    return false;
  }
  const { pathname, search, fullPath } = parseFullPathForMeta(fullPathOrKey);
  const meta = resolveRouteTabMeta(pathname, search, fullPath);
  if (meta.cacheStrategy === 'state') {
    return true;
  }
  if (meta.cacheStrategy === 'none') {
    return false;
  }
  return !isTabRouteKeepAliveEnabled();
}
